// @flow
import {createSelector} from "reselect";
import type {State} from "../../Store";

const serviceConfigSelector = (state: State) => state.serviceConfig;

const getVisualServicePolygonPaths = createSelector(
    serviceConfigSelector,
    (serviceConfig) => {
        return serviceConfig && serviceConfig.visualServicePolygonPaths;
    }
);

const getServicePolygons = createSelector(
    serviceConfigSelector,
    (serviceConfig) => {
        return serviceConfig ? serviceConfig.polygons_list || [] : [];
    }
);

export default {
    serviceConfigSelector,
    getVisualServicePolygonPaths,
    getServicePolygons,
};



// WEBPACK FOOTER //
// ./src/Store/Ducks/ServiceConfig/selectors.js